module.exports = __webpack_public_path__ + "img/buys_color.f0e49644.jpg";